import { render, staticRenderFns } from "./RateInspectorForm.vue?vue&type=template&id=a72b96b8&scoped=true&"
import script from "./RateInspectorForm.vue?vue&type=script&lang=js&"
export * from "./RateInspectorForm.vue?vue&type=script&lang=js&"
import style0 from "./RateInspectorForm.vue?vue&type=style&index=0&id=a72b96b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72b96b8",
  null
  
)

export default component.exports